module.exports = __webpack_public_path__ + "img/icon-warning-forestfire-orange.40d0cea9.svg";